/**
 * Placeholder handlers for Oshar VR Real Estate marketplace actions.
 * TODO: Wire to Stripe checkout, Thirdweb mint, and backend inventory when ready.
 * Do not simulate successful mint or on-chain confirmation here.
 */

export function handleViewDetails(property) {
  // TODO: Open detail route or rich modal fed by API / contract metadata
  // eslint-disable-next-line no-console
  console.info("[Oshar RE] handleViewDetails placeholder", property?.id ?? property?.name);
}

export function handleBuyWithCard(property) {
  // TODO: Create Stripe session or platform checkout for this SKU
  const message =
    "Card reservation is not live yet. This will open secure checkout when enabled.";
  if (typeof window !== "undefined" && typeof window.alert === "function") {
    window.alert(message);
  }
  // eslint-disable-next-line no-console
  console.info("[Oshar RE] handleBuyWithCard placeholder — no charge performed", property?.id ?? property?.name, message);
}

export function handleBuyWithWallet(property) {
  // TODO: Invoke marketplace contract / Thirdweb purchase flow with real ABI + chain
  // eslint-disable-next-line no-console
  console.info("[Oshar RE] handleBuyWithWallet placeholder — no tx sent", property?.id ?? property?.name);
}

export function handleReserveProperty(property) {
  // TODO: Optional hold / allowlist reservation against backend
  // eslint-disable-next-line no-console
  console.info("[Oshar RE] handleReserveProperty placeholder", property?.id ?? property?.name);
}
